import { useState, useEffect } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDbsNyQQZ1M-FvFu_xDiSmGh_ybT3Wlhb4",
  authDomain: "carecrew-tracker.firebaseapp.com",
  projectId: "carecrew-tracker",
  storageBucket: "carecrew-tracker.firebasestorage.app",
  messagingSenderId: "992503319939",
  appId: "1:992503319939:web:e56322244cec62e8177ab6"
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

const SESSION_KEY = "carecrewSession";

const fbGet = async (key) => {
  try {
    const snap = await getDoc(doc(db, "appdata", key));
    return snap.exists() ? snap.data().value : null;
  } catch { return null; }
};
const fbSet = async (key, value) => {
  try { await setDoc(doc(db, "appdata", key), { value }); } catch {}
};

const ADMIN_PASSWORD = "Grace7910";
const VOLUNTEER_PASSWORD = "edu4all";

const NAVY    = "#182241";
const TEAL_D  = "#213c4e";
const TEAL_M  = "#536c7c";
const TEAL_L  = "#7b949c";
const YELLOW  = "#FED25A";
const WHITE   = "#FFFFFF";
const OFFWHITE= "#F4F6F7";
const FONT    = "'PT Serif', Georgia, serif";

const formatDuration = (totalMinutes) => {
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
};

const formatDate = (iso) =>
  new Date(iso + "T00:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" });

const avatarColors = [TEAL_D, "#2563EB", "#059669", TEAL_M, "#7C3AED", "#0891B2"];
const getAvatarColor = (name) => avatarColors[name.charCodeAt(0) % avatarColors.length];

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const DAYS = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

export default function App() {
  const [role, setRole] = useState(null);
  const [volunteerName, setVolunteerName] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginName, setLoginName] = useState("");
  const [loginError, setLoginError] = useState("");

  const [volunteers, setVolunteers] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [availability, setAvailability] = useState({});
  const [news, setNews] = useState([]);
  const [newsTitle, setNewsTitle] = useState("");
  const [newsBody, setNewsBody] = useState("");

  const [view, setView] = useState("dashboard");
  const [selectedVolunteer, setSelectedVolunteer] = useState(null);
  const [newVolName, setNewVolName] = useState("");
  const [newVolEmail, setNewVolEmail] = useState("");
  const [logVolId, setLogVolId] = useState("");
  const [logHours, setLogHours] = useState("");
  const [logMinutes, setLogMinutes] = useState("");
  const [logDate, setLogDate] = useState(new Date().toISOString().slice(0, 10));
  const [logNotes, setLogNotes] = useState("");

  const [meetingTitle, setMeetingTitle] = useState("");
  const [meetingDate, setMeetingDate] = useState("");
  const [meetingTime, setMeetingTime] = useState("");
  const [meetingLocation, setMeetingLocation] = useState("");
  const [meetingNotes, setMeetingNotes] = useState("");

  const today = new Date();
  const [calYear, setCalYear] = useState(today.getFullYear());
  const [calMonth, setCalMonth] = useState(today.getMonth());

  const [reportType, setReportType] = useState("all");
  const [reportVolId, setReportVolId] = useState("");
  const [reportFrom, setReportFrom] = useState("");
  const [reportTo, setReportTo] = useState(new Date().toISOString().slice(0, 10));
  const [reportRecipient, setReportRecipient] = useState("Ghureau@thecarecrew.org");
  const [reportLoading, setReportLoading] = useState(false);
  const [reportPreview, setReportPreview] = useState(null);

  const [toast, setToast] = useState(null);

  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=PT+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    loadData();
  }, []);

  const loadData = async () => {
    const v = await fbGet("volunteers");
    if (v) setVolunteers(JSON.parse(v));
    const m = await fbGet("meetings");
    if (m) setMeetings(JSON.parse(m));
    const a = await fbGet("availability");
    if (a) setAvailability(JSON.parse(a));
    const n = await fbGet("news");
    if (n) setNews(JSON.parse(n));
    try {
      const sessRaw = localStorage.getItem(SESSION_KEY);
      if (sessRaw) {
        const { role: r, name: nm, view: vw } = JSON.parse(sessRaw);
        setRole(r);
        setVolunteerName(nm);
        setView(vw || "home");
      }
    } catch (_) {}
  };

  const saveVolunteers = async (u) => { setVolunteers(u); await fbSet("volunteers", JSON.stringify(u)); };
  const saveMeetings = async (u) => { setMeetings(u); await fbSet("meetings", JSON.stringify(u)); };
  const saveAvailability = async (u) => { setAvailability(u); await fbSet("availability", JSON.stringify(u)); };
  const saveNews = async (u) => { setNews(u); await fbSet("news", JSON.stringify(u)); };

  const showToast = (msg, isError = false) => { setToast({ msg, isError }); setTimeout(() => setToast(null), 2800); };

  const handleLogin = () => {
    setLoginError("");
    if (loginPassword === ADMIN_PASSWORD) {
      setRole("admin"); setVolunteerName("Admin"); setView("home"); localStorage.setItem(SESSION_KEY, JSON.stringify({ role: "admin", name: "Admin", view: "home" }));
    } else if (loginPassword === VOLUNTEER_PASSWORD) {
      if (!loginName.trim()) { setLoginError("Please enter your name."); return; }
      setRole("volunteer"); setVolunteerName(loginName.trim()); setView("home"); localStorage.setItem(SESSION_KEY, JSON.stringify({ role: "volunteer", name: loginName.trim(), view: "home" }));
    } else {
      setLoginError("Incorrect password. Please try again.");
    }
  };

  const addVolunteer = () => {
    if (!newVolName.trim()) return;
    const vol = { id: Date.now().toString(), name: newVolName.trim(), email: newVolEmail.trim(), sessions: [], createdAt: new Date().toISOString() };
    saveVolunteers([...volunteers, vol]);
    setNewVolName(""); setNewVolEmail(""); showToast(`${vol.name} added!`);
  };

  const logHoursSubmit = () => {
    const h = parseInt(logHours) || 0;
    const m = parseInt(logMinutes) || 0;
    const total = h * 60 + m;
    if (!logVolId || total === 0) return;
    const updated = volunteers.map((v) =>
      v.id === logVolId ? { ...v, sessions: [...v.sessions, { id: Date.now().toString(), date: logDate, minutes: total, notes: logNotes }] } : v
    );
    saveVolunteers(updated);
    const vol = volunteers.find((v) => v.id === logVolId);
    showToast(`Logged ${formatDuration(total)} for ${vol?.name}!`);
    setLogHours(""); setLogMinutes(""); setLogNotes("");
  };

  const deleteSession = (volId, sessionId) => {
    saveVolunteers(volunteers.map((v) => v.id === volId ? { ...v, sessions: v.sessions.filter((s) => s.id !== sessionId) } : v));
    showToast("Session removed", true);
  };

  const deleteVolunteer = (id) => {
    saveVolunteers(volunteers.filter((v) => v.id !== id));
    if (selectedVolunteer?.id === id) setSelectedVolunteer(null);
    showToast("Volunteer removed", true);
  };

  const addMeeting = () => {
    if (!meetingTitle.trim() || !meetingDate) return;
    const meeting = { id: Date.now().toString(), title: meetingTitle.trim(), date: meetingDate, time: meetingTime, location: meetingLocation.trim(), notes: meetingNotes.trim(), rsvps: {} };
    saveMeetings([...meetings, meeting]);
    setMeetingTitle(""); setMeetingDate(""); setMeetingTime(""); setMeetingLocation(""); setMeetingNotes("");
    showToast("Meeting added!");
  };

  const deleteMeeting = (id) => { saveMeetings(meetings.filter((m) => m.id !== id)); showToast("Meeting removed", true); };

  const rsvpMeeting = (meetingId, response) => {
    const updated = meetings.map((m) => m.id === meetingId ? { ...m, rsvps: { ...m.rsvps, [volunteerName]: response } } : m);
    saveMeetings(updated);
    showToast(response === "yes" ? "You're attending! 🎉" : "RSVP updated.");
  };

  const toggleAvailability = (dateStr) => {
    const current = availability[dateStr] || [];
    const updated = current.includes(volunteerName)
      ? { ...availability, [dateStr]: current.filter((n) => n !== volunteerName) }
      : { ...availability, [dateStr]: [...current, volunteerName] };
    saveAvailability(updated);
  };

  const isAvailable = (dateStr) => (availability[dateStr] || []).includes(volunteerName);

  const getDaysInMonth = (y, m) => new Date(y, m + 1, 0).getDate();
  const getFirstDay = (y, m) => new Date(y, m, 1).getDay();
  const getMeetingsOnDate = (d) => meetings.filter((m) => m.date === d);
  const getAvailableOnDate = (d) => availability[d] || [];
  const todayStr = new Date().toISOString().slice(0, 10);

  const totalMinutesAll = volunteers.reduce((acc, v) => acc + v.sessions.reduce((a, s) => a + s.minutes, 0), 0);
  const topVolunteers = [...volunteers].map((v) => ({ ...v, total: v.sessions.reduce((a, s) => a + s.minutes, 0) })).sort((a, b) => b.total - a.total).slice(0, 5);
  const upcomingMeetings = meetings.filter((m) => m.date >= todayStr).sort((a, b) => a.date.localeCompare(b.date));
  const pastMeetings = meetings.filter((m) => m.date < todayStr).sort((a, b) => b.date.localeCompare(a.date));

  const addNews = () => {
    if (!newsTitle.trim() && !newsBody.trim()) return;
    const post = { id: Date.now().toString(), title: newsTitle.trim(), body: newsBody.trim(), date: new Date().toISOString() };
    saveNews([post, ...news]);
    setNewsTitle(""); setNewsBody("");
    showToast("News posted!");
  };
  const deleteNews = (id) => { saveNews(news.filter((n) => n.id !== id)); showToast("Post removed", true); };

  const generateReport = async () => {
    setReportLoading(true); setReportPreview(null);
    let vols = volunteers;
    if (reportType === "individual" && reportVolId) vols = volunteers.filter((v) => v.id === reportVolId);
    const data = vols.map((v) => {
      let sessions = v.sessions;
      if (reportType === "daterange" && reportFrom) sessions = sessions.filter((s) => s.date >= reportFrom && s.date <= reportTo);
      return { name: v.name, email: v.email, sessions, totalMins: sessions.reduce((a, s) => a + s.minutes, 0) };
    });
    const totalAll = data.reduce((a, v) => a + v.totalMins, 0);
    const todayFmt = new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
    let rangeLabel = "All Time";
    if (reportType === "individual") rangeLabel = `Individual Report – ${data[0]?.name || ""}`;
    else if (reportType === "daterange") rangeLabel = `${formatDate(reportFrom)} – ${formatDate(reportTo)}`;
    const dataStr = data.map((v) => {
      const lines = v.sessions.sort((a, b) => new Date(b.date) - new Date(a.date)).map((s) => `  - ${formatDate(s.date)}: ${formatDuration(s.minutes)}${s.notes ? ` (${s.notes})` : ""}`).join("\n");
      return `Volunteer: ${v.name}${v.email ? ` <${v.email}>` : ""}\nTotal: ${formatDuration(v.totalMins)}\nSessions:\n${lines || "  (none)"}`;
    }).join("\n\n");
    const prompt = `You are writing a professional volunteer hours report email for CareCrew (thecarecrew.org), a nonprofit in Fisherville, Kentucky that provides school supplies to students in need.\n\nReport Period: ${rangeLabel}\nReport Date: ${todayFmt}\nTotal Volunteer Hours: ${formatDuration(totalAll)}\nActive Volunteers: ${data.filter((v) => v.totalMins > 0).length}\n\nVOLUNTEER DATA:\n${dataStr}\n\nWrite a warm, professional email in plain text only (no markdown, no asterisks, no hashtags). Include:\n1. A warm greeting\n2. Brief summary of total hours\n3. Breakdown of each volunteer's hours\n4. Heartfelt closing about community impact\n5. Sign off as "The CareCrew Leadership Team"\n\nPlain text only.`;
    try {
      const res = await fetch("https://api.anthropic.com/v1/messages", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ model: "claude-sonnet-4-20250514", max_tokens: 1000, messages: [{ role: "user", content: prompt }] }) });
      const result = await res.json();
      setReportPreview({ text: result.content?.map((c) => c.text || "").join("") || "", rangeLabel, totalAll });
    } catch { showToast("Failed to generate report.", true); }
    setReportLoading(false);
  };

  const openMailto = () => {
    if (!reportPreview) return;
    window.open(`mailto:${reportRecipient}?subject=${encodeURIComponent(`CareCrew Volunteer Hours Report – ${reportPreview.rangeLabel}`)}&body=${encodeURIComponent(reportPreview.text)}`, "_blank");
  };

  // ── Styles ────────────────────────────────────────────────────────────────
  const s = {
    app: { fontFamily: FONT, background: OFFWHITE, minHeight: "100vh", color: NAVY },
    header: { background: WHITE, padding: "0 28px", display: "flex", alignItems: "stretch", justifyContent: "space-between", flexWrap: "wrap", borderBottom: `4px solid ${YELLOW}`, boxShadow: "0 2px 12px rgba(24,34,65,0.10)" },
    logoWrap: { display: "flex", alignItems: "center", gap: "14px", padding: "16px 0" },
    logoMark: { background: YELLOW, color: NAVY, fontWeight: "800", fontSize: "0.95rem", letterSpacing: "0.04em", padding: "7px 14px", borderRadius: "3px", textTransform: "uppercase" },
    logoSub: { color: TEAL_M, fontSize: "0.65rem", letterSpacing: "0.16em", textTransform: "uppercase", fontWeight: "600" },
    nav: { display: "flex", alignItems: "stretch", flexWrap: "wrap" },
    navBtn: (active) => ({ padding: "0 14px", border: "none", borderBottom: active ? `3px solid ${YELLOW}` : "3px solid transparent", borderTop: "3px solid transparent", background: "transparent", color: active ? NAVY : TEAL_M, fontFamily: FONT, fontSize: "0.65rem", fontWeight: active ? "700" : "500", letterSpacing: "0.1em", textTransform: "uppercase", cursor: "pointer", transition: "all 0.15s", whiteSpace: "nowrap" }),
    userBar: { display: "flex", alignItems: "center", gap: "10px", padding: "0 0 0 12px" },
    logoutBtn: { background: "none", border: `1px solid ${TEAL_L}`, color: TEAL_M, fontFamily: FONT, fontSize: "0.65rem", fontWeight: "600", letterSpacing: "0.08em", textTransform: "uppercase", padding: "5px 12px", borderRadius: "3px", cursor: "pointer" },
    main: { maxWidth: "980px", margin: "0 auto", padding: "32px 20px" },
    pageTitle: { fontSize: "1.4rem", fontWeight: "800", color: NAVY, marginBottom: "24px", letterSpacing: "-0.02em" },
    card: { background: WHITE, borderRadius: "6px", padding: "26px", marginBottom: "18px", boxShadow: "0 1px 6px rgba(24,34,65,0.08)", border: "1px solid #dde3e8" },
    cardTitle: { fontWeight: "800", color: NAVY, marginBottom: "18px", fontSize: "0.67rem", letterSpacing: "0.14em", textTransform: "uppercase", display: "flex", alignItems: "center", gap: "10px" },
    bar: { display: "inline-block", width: "4px", height: "14px", background: YELLOW, borderRadius: "2px", flexShrink: 0 },
    statGrid: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "14px", marginBottom: "22px" },
    stat: { background: TEAL_D, borderRadius: "6px", padding: "24px 16px", textAlign: "center", boxShadow: "0 2px 8px rgba(24,34,65,0.15)" },
    statNum: { fontSize: "2.1rem", fontWeight: "800", color: YELLOW, letterSpacing: "-0.03em" },
    statLabel: { fontSize: "0.65rem", color: TEAL_L, textTransform: "uppercase", letterSpacing: "0.12em", marginTop: "4px", fontWeight: "600" },
    input: { width: "100%", padding: "10px 13px", border: "1.5px solid #dde3e8", borderRadius: "4px", fontFamily: FONT, fontSize: "0.87rem", color: NAVY, background: WHITE, boxSizing: "border-box", outline: "none" },
    label: { display: "block", fontSize: "0.67rem", fontWeight: "700", color: TEAL_M, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: "5px" },
    btn: (variant = "primary") => {
      const variants = { primary: { background: YELLOW, color: NAVY, border: "2px solid transparent" }, outline: { background: "transparent", color: NAVY, border: "2px solid #dde3e8" }, dark: { background: NAVY, color: WHITE, border: "2px solid transparent" }, danger: { background: "transparent", color: TEAL_M, border: "2px solid #dde3e8" }, green: { background: "#059669", color: WHITE, border: "2px solid transparent" }, red: { background: "#DC2626", color: WHITE, border: "2px solid transparent" } };
      return { ...variants[variant], padding: "10px 20px", borderRadius: "4px", cursor: "pointer", fontFamily: FONT, fontSize: "0.75rem", fontWeight: "700", letterSpacing: "0.08em", textTransform: "uppercase", transition: "all 0.15s" };
    },
    grid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "13px" },
    grid3: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "13px" },
    volRow: { display: "flex", alignItems: "center", padding: "13px 0", borderBottom: "1px solid #edf0f2", gap: "13px" },
    avatar: (color) => ({ width: "34px", height: "34px", borderRadius: "4px", background: color, display: "flex", alignItems: "center", justifyContent: "center", color: WHITE, fontWeight: "800", fontSize: "0.85rem", flexShrink: 0 }),
    badge: { background: `${YELLOW}30`, color: "#8a6800", padding: "4px 11px", borderRadius: "3px", fontSize: "0.7rem", fontWeight: "700", marginLeft: "auto", letterSpacing: "0.04em" },
    toast: (isError) => ({ position: "fixed", bottom: "24px", left: "50%", transform: "translateX(-50%)", background: isError ? TEAL_D : NAVY, borderLeft: `4px solid ${YELLOW}`, color: WHITE, padding: "12px 26px", borderRadius: "4px", fontWeight: "700", boxShadow: "0 4px 20px rgba(24,34,65,0.3)", zIndex: 9999, fontSize: "0.75rem", letterSpacing: "0.06em", textTransform: "uppercase" }),
    radio: (active) => ({ padding: "8px 18px", borderRadius: "4px", border: `2px solid ${active ? NAVY : "#dde3e8"}`, background: active ? NAVY : WHITE, color: active ? YELLOW : TEAL_M, cursor: "pointer", fontFamily: FONT, fontSize: "0.7rem", fontWeight: "700", letterSpacing: "0.08em", textTransform: "uppercase", transition: "all 0.15s" }),
  };

  const CT = ({ children }) => <div style={s.cardTitle}><span style={s.bar} />{children}</div>;

  // ── LOGIN ─────────────────────────────────────────────────────────────────
  if (!role) {
    return (
      <div style={{ ...s.app, display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: NAVY }}>
        <div style={{ background: WHITE, borderRadius: "8px", padding: "48px 40px", width: "100%", maxWidth: "400px", boxShadow: "0 8px 40px rgba(24,34,65,0.3)" }}>
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <div style={{ background: YELLOW, color: NAVY, fontWeight: "800", fontSize: "1.1rem", letterSpacing: "0.04em", padding: "9px 18px", borderRadius: "3px", textTransform: "uppercase", display: "inline-block", marginBottom: "14px" }}>CareCrew</div>
            <div style={{ fontSize: "0.72rem", color: TEAL_M, letterSpacing: "0.14em", textTransform: "uppercase", fontWeight: "600" }}>Volunteer Tracker · Sign In</div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <div>
              <label style={s.label}>Your Name</label>
              <input style={s.input} type="text" placeholder="e.g. Jane Smith" value={loginName} onChange={(e) => setLoginName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleLogin()} />
              <div style={{ fontSize: "0.65rem", color: TEAL_L, marginTop: "5px" }}>Admins may leave this blank</div>
            </div>
            <div>
              <label style={s.label}>Password</label>
              <input style={s.input} type="password" placeholder="Enter password" value={loginPassword} onChange={(e) => setLoginPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleLogin()} />
            </div>
            {loginError && <div style={{ color: "#DC2626", fontSize: "0.78rem", fontWeight: "600" }}>{loginError}</div>}
            <button style={{ ...s.btn("primary"), width: "100%", padding: "13px" }} onClick={handleLogin}>Sign In</button>
          </div>
        </div>
      </div>
    );
  }

  const adminNav = [["home","Home"],["about","About"],["dashboard","Dashboard"],["log","Log Hours"],["volunteers","Volunteers"],["history","History"],["calendar","Calendar"],["meetings","Meetings"],["availability","Availability"],["email","Email Report"]];
  const volNav = [["home","Home"],["about","About"],["myhours","My Hours"],["calendar","Calendar"],["meetings","Meetings"],["availability","My Availability"]];
  const navItems = role === "admin" ? adminNav : volNav;

  // ── CALENDAR RENDER ───────────────────────────────────────────────────────
  const renderCalendar = () => {
    const daysInMonth = getDaysInMonth(calYear, calMonth);
    const firstDay = getFirstDay(calYear, calMonth);
    const cells = [...Array(firstDay).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => i + 1)];

    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "18px" }}>
          <button style={{ ...s.btn("outline"), padding: "7px 14px" }} onClick={() => { if (calMonth === 0) { setCalMonth(11); setCalYear(calYear - 1); } else setCalMonth(calMonth - 1); }}>‹</button>
          <div style={{ fontWeight: "800", fontSize: "1.05rem", color: NAVY }}>{MONTHS[calMonth]} {calYear}</div>
          <button style={{ ...s.btn("outline"), padding: "7px 14px" }} onClick={() => { if (calMonth === 11) { setCalMonth(0); setCalYear(calYear + 1); } else setCalMonth(calMonth + 1); }}>›</button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "3px", marginBottom: "4px" }}>
          {DAYS.map((d) => <div key={d} style={{ textAlign: "center", fontSize: "0.62rem", fontWeight: "700", color: TEAL_M, letterSpacing: "0.08em", textTransform: "uppercase", padding: "4px 0" }}>{d}</div>)}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "3px" }}>
          {cells.map((day, i) => {
            if (!day) return <div key={`e${i}`} />;
            const ds = `${calYear}-${String(calMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
            const dayMeetings = getMeetingsOnDate(ds);
            const dayAvail = getAvailableOnDate(ds);
            const isToday = ds === todayStr;
            const isPast = ds < todayStr;
            const iAmAvail = role === "volunteer" && isAvailable(ds);
            return (
              <div key={ds} onClick={() => role === "volunteer" && !isPast && toggleAvailability(ds)}
                style={{ minHeight: "68px", padding: "5px", borderRadius: "4px", border: isToday ? `2px solid ${YELLOW}` : "1px solid #edf0f2", background: iAmAvail ? `${YELLOW}28` : isPast ? "#f9fafb" : WHITE, cursor: role === "volunteer" && !isPast ? "pointer" : "default", transition: "background 0.12s" }}>
                <div style={{ fontWeight: isToday ? "800" : "600", fontSize: "0.8rem", color: isPast ? TEAL_L : NAVY, marginBottom: "3px" }}>{day}</div>
                {dayMeetings.map((m) => (
                  <div key={m.id} style={{ background: NAVY, color: YELLOW, fontSize: "0.55rem", fontWeight: "700", padding: "2px 4px", borderRadius: "2px", marginBottom: "2px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{m.title}</div>
                ))}
                {dayAvail.length > 0 && <div style={{ fontSize: "0.58rem", color: "#059669", fontWeight: "700", marginTop: "2px" }}>✓ {dayAvail.length}</div>}
              </div>
            );
          })}
        </div>
        {role === "volunteer" && (
          <div style={{ marginTop: "14px", padding: "10px 14px", background: `${YELLOW}20`, borderRadius: "4px", fontSize: "0.75rem", color: NAVY, fontWeight: "600" }}>
            💡 Tap any future date to mark yourself available. Tap again to remove.
          </div>
        )}
      </div>
    );
  };

  // ── MAIN RENDER ───────────────────────────────────────────────────────────
  return (
    <div style={s.app}>
      <div style={s.header}>
        <div style={s.logoWrap}>
          <div style={s.logoMark}>CareCrew</div>
          <div style={s.logoSub}>Volunteer Tracker</div>
        </div>
        <nav style={s.nav}>
          {navItems.map(([key, label]) => (
            <button key={key} style={s.navBtn(view === key)} onClick={() => setView(key)}>{label}</button>
          ))}
          <div style={s.userBar}>
            <span style={{ color: TEAL_M, fontSize: "0.65rem", fontWeight: "600" }}>{volunteerName}</span>
            <button style={s.logoutBtn} onClick={() => { setRole(null); setLoginPassword(""); setLoginName(""); localStorage.removeItem(SESSION_KEY); }}>Sign Out</button>
          </div>
        </nav>
      </div>

      <div style={s.main}>

        {/* HOME - visible to all */}
        {view === "home" && (
          <>
            {/* News post form (admin only) */}
            {role === "admin" && (
              <div style={s.card}>
                <CT>Post News Update</CT>
                <div style={{ display: "flex", flexDirection: "column", gap: "13px" }}>
                  <div><label style={s.label}>Headline</label><input type="text" placeholder="e.g. School Supply Drive This Saturday!" style={s.input} value={newsTitle} onChange={(e) => setNewsTitle(e.target.value)} /></div>
                  <div><label style={s.label}>Details</label><textarea placeholder="Share details with your volunteers..." style={{ ...s.input, minHeight: "90px", resize: "vertical", lineHeight: "1.6" }} value={newsBody} onChange={(e) => setNewsBody(e.target.value)} /></div>
                  <div><button style={s.btn("primary")} onClick={addNews}>Post Update</button></div>
                </div>
              </div>
            )}

            {/* News feed */}
            <div style={s.card}>
              <CT>Latest News</CT>
              {news.length === 0 && <p style={{ color: TEAL_M, fontSize: "0.88rem" }}>No news posted yet.</p>}
              {news.map((post) => (
                <div key={post.id} style={{ paddingBottom: "18px", marginBottom: "18px", borderBottom: "1px solid #edf0f2" }}>
                  <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "12px" }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "800", fontSize: "1rem", color: NAVY, marginBottom: "4px" }}>{post.title}</div>
                      <div style={{ fontSize: "0.7rem", color: TEAL_L, fontWeight: "600", marginBottom: "8px" }}>{new Date(post.date).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</div>
                      {post.body && <div style={{ fontSize: "0.88rem", color: TEAL_M, lineHeight: "1.65", whiteSpace: "pre-wrap" }}>{post.body}</div>}
                    </div>
                    {role === "admin" && <button onClick={() => deleteNews(post.id)} style={{ background: "none", border: "none", cursor: "pointer", color: TEAL_L, fontSize: "1rem", padding: "0 4px", flexShrink: 0 }}>✕</button>}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {/* ABOUT */}
        {view === "about" && (
          <div>
            {/* Who We Are */}
            <div style={{ background: NAVY, borderRadius: "8px", padding: "40px 36px", marginBottom: "22px", position: "relative", overflow: "hidden" }}>
              <div style={{ position: "absolute", top: 0, left: 0, width: "6px", height: "100%", background: YELLOW }} />
              <div style={{ paddingLeft: "20px" }}>
                <div style={{ fontSize: "0.65rem", fontWeight: "800", letterSpacing: "0.18em", textTransform: "uppercase", color: YELLOW, marginBottom: "10px" }}>Who We Are</div>
                <p style={{ fontSize: "1.05rem", lineHeight: "1.8", color: WHITE, fontWeight: "500", margin: 0 }}>
                  We believe full-heartedly that education should not be limited to anyone, no matter their race, culture, background, or circumstances. Learning and education should be open to all who want it, and we're here to help that happen.
                </p>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "18px", marginBottom: "22px" }}>
              {/* Vision */}
              <div style={{ background: WHITE, borderRadius: "8px", padding: "28px", boxShadow: "0 1px 6px rgba(24,34,65,0.08)", border: "1px solid #dde3e8", borderTop: `4px solid ${YELLOW}` }}>
                <div style={{ fontSize: "0.65rem", fontWeight: "800", letterSpacing: "0.16em", textTransform: "uppercase", color: TEAL_M, marginBottom: "12px" }}>Our Vision</div>
                <p style={{ fontSize: "0.92rem", lineHeight: "1.75", color: NAVY, margin: 0 }}>
                  CareCrew's vision is a world where basic education is accessible to all communities, and children everywhere will have the support they need to attend school. We plan to build our community in our home, Kentucky, and reach communities outside of the United States in the near future.
                </p>
              </div>

              {/* Mission */}
              <div style={{ background: WHITE, borderRadius: "8px", padding: "28px", boxShadow: "0 1px 6px rgba(24,34,65,0.08)", border: "1px solid #dde3e8", borderTop: `4px solid ${YELLOW}` }}>
                <div style={{ fontSize: "0.65rem", fontWeight: "800", letterSpacing: "0.16em", textTransform: "uppercase", color: TEAL_M, marginBottom: "12px" }}>Our Mission</div>
                <p style={{ fontSize: "0.92rem", lineHeight: "1.75", color: NAVY, margin: 0 }}>
                  Our mission is to provide educational resources to children and communities around the globe who may struggle to afford the materials necessary for school, paving the path for future generations.
                </p>
              </div>
            </div>

            {/* Values */}
            <div style={{ background: WHITE, borderRadius: "8px", padding: "32px", boxShadow: "0 1px 6px rgba(24,34,65,0.08)", border: "1px solid #dde3e8" }}>
              <div style={{ fontSize: "0.65rem", fontWeight: "800", letterSpacing: "0.16em", textTransform: "uppercase", color: TEAL_M, marginBottom: "22px" }}>Our Values</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                {[
                  ["Teamwork", "We believe that two are always better than one and goals can truly be achieved through combined efforts."],
                  ["Innovation", "The world is constantly changing, so the development of new ideas, suggestions, and questions is a must in our non-profit."],
                  ["Perseverance", "We appreciate the value of surmounting struggles because it provides anyone with the skills they need to flourish."],
                  ["Respect", "We attest that one of the most important gestures that anyone can give is respect."],
                ].map(([title, desc]) => (
                  <div key={title} style={{ display: "flex", gap: "14px", alignItems: "flex-start" }}>
                    <div style={{ background: YELLOW, color: NAVY, borderRadius: "3px", padding: "6px 10px", fontWeight: "800", fontSize: "0.7rem", letterSpacing: "0.06em", textTransform: "uppercase", flexShrink: 0, marginTop: "2px" }}>{title}</div>
                    <p style={{ fontSize: "0.88rem", lineHeight: "1.65", color: TEAL_M, margin: 0 }}>{desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* DASHBOARD */}
        {view === "dashboard" && role === "admin" && (
          <>
            <div style={s.pageTitle}>Overview</div>
            <div style={s.statGrid}>
              {[[volunteers.length,"Volunteers"],[formatDuration(totalMinutesAll),"Total Hours"],[upcomingMeetings.length,"Upcoming Meetings"]].map(([num, label]) => (
                <div key={label} style={s.stat}><div style={s.statNum}>{num}</div><div style={s.statLabel}>{label}</div></div>
              ))}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "18px" }}>
              <div style={s.card}>
                <CT>Top Volunteers</CT>
                {topVolunteers.length === 0 && <p style={{ color: TEAL_M, fontSize: "0.88rem" }}>No volunteers yet.</p>}
                {topVolunteers.map((v, i) => (
                  <div key={v.id} style={s.volRow}>
                    <span style={{ color: TEAL_L, fontSize: "0.72rem", width: "20px", fontWeight: "700" }}>#{i+1}</span>
                    <div style={s.avatar(getAvatarColor(v.name))}>{v.name[0].toUpperCase()}</div>
                    <div style={{ fontWeight: "700", fontSize: "0.88rem" }}>{v.name}</div>
                    <div style={s.badge}>{formatDuration(v.total)}</div>
                  </div>
                ))}
              </div>
              <div style={s.card}>
                <CT>Upcoming Meetings</CT>
                {upcomingMeetings.length === 0 && <p style={{ color: TEAL_M, fontSize: "0.88rem" }}>No upcoming meetings.</p>}
                {upcomingMeetings.slice(0, 5).map((m) => (
                  <div key={m.id} style={s.volRow}>
                    <div style={{ background: YELLOW, color: NAVY, borderRadius: "3px", padding: "4px 8px", fontSize: "0.65rem", fontWeight: "800", flexShrink: 0, textAlign: "center" }}>
                      <div>{new Date(m.date + "T00:00:00").getDate()}</div>
                      <div>{new Date(m.date + "T00:00:00").toLocaleDateString("en-US", { month: "short" })}</div>
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "700", fontSize: "0.88rem" }}>{m.title}</div>
                      {m.time && <div style={{ fontSize: "0.7rem", color: TEAL_M }}>{m.time}{m.location ? ` · ${m.location}` : ""}</div>}
                    </div>
                    <div style={s.badge}>{Object.values(m.rsvps||{}).filter(r=>r==="yes").length} going</div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {/* LOG HOURS */}
        {view === "log" && role === "admin" && (
          <div style={s.card}>
            <CT>Log Volunteer Hours</CT>
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div><label style={s.label}>Volunteer *</label>
                <select style={s.input} value={logVolId} onChange={(e) => setLogVolId(e.target.value)}>
                  <option value="">— Select —</option>
                  {volunteers.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}
                </select>
              </div>
              <div><label style={s.label}>Date *</label><input type="date" style={s.input} value={logDate} onChange={(e) => setLogDate(e.target.value)} /></div>
              <div style={s.grid2}>
                <div><label style={s.label}>Hours</label><input type="number" min="0" max="24" placeholder="0" style={s.input} value={logHours} onChange={(e) => setLogHours(e.target.value)} /></div>
                <div><label style={s.label}>Minutes</label><input type="number" min="0" max="59" placeholder="0" style={s.input} value={logMinutes} onChange={(e) => setLogMinutes(e.target.value)} /></div>
              </div>
              <div><label style={s.label}>Notes (optional)</label><input type="text" placeholder="e.g. School supply drive packing" style={s.input} value={logNotes} onChange={(e) => setLogNotes(e.target.value)} /></div>
              <div><button style={s.btn("primary")} onClick={logHoursSubmit}>Save Session</button></div>
            </div>
          </div>
        )}

        {/* VOLUNTEERS */}
        {view === "volunteers" && role === "admin" && (
          <>
            <div style={s.card}>
              <CT>Add New Volunteer</CT>
              <div style={{ display: "flex", gap: "13px", flexWrap: "wrap", alignItems: "flex-end" }}>
                <div style={{ flex: 1, minWidth: "160px" }}><label style={s.label}>Full Name *</label><input type="text" placeholder="Jane Smith" style={s.input} value={newVolName} onChange={(e) => setNewVolName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addVolunteer()} /></div>
                <div style={{ flex: 1, minWidth: "160px" }}><label style={s.label}>Email (optional)</label><input type="email" placeholder="jane@email.com" style={s.input} value={newVolEmail} onChange={(e) => setNewVolEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addVolunteer()} /></div>
                <div><button style={s.btn("primary")} onClick={addVolunteer}>Add</button></div>
              </div>
            </div>
            <div style={s.card}>
              <CT>All Volunteers ({volunteers.length})</CT>
              {volunteers.length === 0 && <p style={{ color: TEAL_M, fontSize: "0.88rem" }}>No volunteers yet.</p>}
              {volunteers.map((v) => {
                const total = v.sessions.reduce((a, s) => a + s.minutes, 0);
                return (
                  <div key={v.id} style={s.volRow}>
                    <div style={s.avatar(getAvatarColor(v.name))}>{v.name[0].toUpperCase()}</div>
                    <div><div style={{ fontWeight: "700" }}>{v.name}</div>{v.email && <div style={{ fontSize: "0.7rem", color: TEAL_M }}>{v.email}</div>}</div>
                    <div style={s.badge}>{formatDuration(total)}</div>
                    <button onClick={() => { setSelectedVolunteer(v); setView("history"); }} style={{ ...s.btn("outline"), padding: "6px 13px", marginLeft: "6px" }}>View</button>
                    <button onClick={() => deleteVolunteer(v.id)} style={{ ...s.btn("danger"), padding: "6px 13px" }}>Remove</button>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {/* HISTORY */}
        {view === "history" && role === "admin" && (
          <div style={s.card}>
            <CT>Session History</CT>
            <div style={{ marginBottom: "18px" }}>
              <label style={s.label}>Filter by Volunteer</label>
              <select style={s.input} value={selectedVolunteer?.id || ""} onChange={(e) => setSelectedVolunteer(volunteers.find((v) => v.id === e.target.value) || null)}>
                <option value="">— All Volunteers —</option>
                {volunteers.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}
              </select>
            </div>
            {(() => {
              const rows = [];
              const vols = selectedVolunteer ? volunteers.filter((v) => v.id === selectedVolunteer.id) : volunteers;
              for (const v of vols) for (const sess of v.sessions) rows.push({ ...sess, volName: v.name, volId: v.id });
              rows.sort((a, b) => new Date(b.date) - new Date(a.date));
              if (rows.length === 0) return <p style={{ color: TEAL_M, fontSize: "0.88rem" }}>No sessions logged yet.</p>;
              return rows.map((r) => (
                <div key={r.id} style={{ ...s.volRow, alignItems: "flex-start" }}>
                  <div style={{ minWidth: "88px", fontSize: "0.7rem", color: TEAL_M, paddingTop: "3px", fontWeight: "600" }}>{formatDate(r.date)}</div>
                  <div style={s.avatar(getAvatarColor(r.volName))}>{r.volName[0].toUpperCase()}</div>
                  <div style={{ flex: 1 }}><div style={{ fontWeight: "700", fontSize: "0.88rem" }}>{r.volName}</div>{r.notes && <div style={{ fontSize: "0.7rem", color: TEAL_M }}>{r.notes}</div>}</div>
                  <div style={s.badge}>{formatDuration(r.minutes)}</div>
                  <button onClick={() => deleteSession(r.volId, r.id)} style={{ background: "none", border: "none", cursor: "pointer", color: TEAL_L, fontSize: "1rem", padding: "0 4px" }}>✕</button>
                </div>
              ));
            })()}
          </div>
        )}

        {/* CALENDAR */}
        {view === "calendar" && (
          <div style={s.card}>
            <CT>{role === "volunteer" ? `Calendar — Tap to Mark Your Availability` : "Calendar"}</CT>
            {renderCalendar()}
          </div>
        )}

        {/* MEETINGS */}
        {view === "meetings" && (
          <>
            {role === "admin" && (
              <div style={s.card}>
                <CT>Schedule a Meeting</CT>
                <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                  <div><label style={s.label}>Title *</label><input type="text" placeholder="e.g. Monthly Volunteer Meeting" style={s.input} value={meetingTitle} onChange={(e) => setMeetingTitle(e.target.value)} /></div>
                  <div style={s.grid3}>
                    <div><label style={s.label}>Date *</label><input type="date" style={s.input} value={meetingDate} onChange={(e) => setMeetingDate(e.target.value)} /></div>
                    <div><label style={s.label}>Time</label><input type="time" style={s.input} value={meetingTime} onChange={(e) => setMeetingTime(e.target.value)} /></div>
                    <div><label style={s.label}>Location</label><input type="text" placeholder="e.g. Community Center" style={s.input} value={meetingLocation} onChange={(e) => setMeetingLocation(e.target.value)} /></div>
                  </div>
                  <div><label style={s.label}>Notes</label><input type="text" placeholder="Any additional details..." style={s.input} value={meetingNotes} onChange={(e) => setMeetingNotes(e.target.value)} /></div>
                  <div><button style={s.btn("primary")} onClick={addMeeting}>Add Meeting</button></div>
                </div>
              </div>
            )}
            <div style={s.card}>
              <CT>Upcoming Meetings</CT>
              {upcomingMeetings.length === 0 && <p style={{ color: TEAL_M, fontSize: "0.88rem" }}>No upcoming meetings scheduled.</p>}
              {upcomingMeetings.map((m) => {
                const myRsvp = m.rsvps?.[volunteerName];
                const yesCount = Object.values(m.rsvps||{}).filter(r=>r==="yes").length;
                const noCount = Object.values(m.rsvps||{}).filter(r=>r==="no").length;
                return (
                  <div key={m.id} style={{ ...s.card, marginBottom: "12px", border: "1px solid #edf0f2" }}>
                    <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", alignItems: "flex-start" }}>
                      <div style={{ background: NAVY, color: YELLOW, borderRadius: "4px", padding: "10px 12px", textAlign: "center", flexShrink: 0 }}>
                        <div style={{ fontSize: "1.3rem", fontWeight: "800", lineHeight: 1 }}>{new Date(m.date + "T00:00:00").getDate()}</div>
                        <div style={{ fontSize: "0.62rem", fontWeight: "700", letterSpacing: "0.08em", textTransform: "uppercase" }}>{new Date(m.date + "T00:00:00").toLocaleDateString("en-US", { month: "short" })}</div>
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: "800", fontSize: "1rem", color: NAVY, marginBottom: "4px" }}>{m.title}</div>
                        <div style={{ fontSize: "0.75rem", color: TEAL_M }}>{m.time && <span>{m.time} </span>}{m.location && <span>· {m.location}</span>}</div>
                        {m.notes && <div style={{ fontSize: "0.72rem", color: TEAL_L, marginTop: "4px" }}>{m.notes}</div>}
                        <div style={{ marginTop: "10px", fontSize: "0.7rem", color: TEAL_M, fontWeight: "600" }}>✓ {yesCount} attending · ✗ {noCount} not attending</div>
                        {role === "admin" && Object.keys(m.rsvps||{}).length > 0 && (
                          <div style={{ marginTop: "8px", display: "flex", flexWrap: "wrap", gap: "5px" }}>
                            {Object.entries(m.rsvps).map(([name, resp]) => (
                              <span key={name} style={{ background: resp==="yes" ? "#D1FAE5" : "#FEE2E2", color: resp==="yes" ? "#065F46" : "#991B1B", padding: "3px 9px", borderRadius: "3px", fontSize: "0.65rem", fontWeight: "700" }}>{name}: {resp==="yes" ? "Going" : "Not going"}</span>
                            ))}
                          </div>
                        )}
                        {role === "volunteer" && (
                          <div style={{ marginTop: "12px", display: "flex", gap: "8px" }}>
                            <button onClick={() => rsvpMeeting(m.id, "yes")} style={{ ...s.btn(myRsvp==="yes" ? "green" : "outline"), padding: "7px 15px", fontSize: "0.7rem" }}>✓ Going</button>
                            <button onClick={() => rsvpMeeting(m.id, "no")} style={{ ...s.btn(myRsvp==="no" ? "red" : "outline"), padding: "7px 15px", fontSize: "0.7rem" }}>✗ Not Going</button>
                          </div>
                        )}
                      </div>
                      {role === "admin" && <button onClick={() => deleteMeeting(m.id)} style={{ background: "none", border: "none", cursor: "pointer", color: TEAL_L, fontSize: "1.1rem" }}>✕</button>}
                    </div>
                  </div>
                );
              })}
              {pastMeetings.length > 0 && (
                <>
                  <div style={{ fontSize: "0.68rem", fontWeight: "700", color: TEAL_L, letterSpacing: "0.1em", textTransform: "uppercase", margin: "18px 0 10px" }}>Past Meetings</div>
                  {pastMeetings.map((m) => (
                    <div key={m.id} style={{ ...s.volRow, opacity: 0.55 }}>
                      <div style={{ fontSize: "0.72rem", color: TEAL_M, fontWeight: "600", minWidth: "80px" }}>{formatDate(m.date)}</div>
                      <div style={{ fontWeight: "700", flex: 1, fontSize: "0.88rem" }}>{m.title}</div>
                      {role === "admin" && <button onClick={() => deleteMeeting(m.id)} style={{ background: "none", border: "none", cursor: "pointer", color: TEAL_L, fontSize: "1rem" }}>✕</button>}
                    </div>
                  ))}
                </>
              )}
            </div>
          </>
        )}

        {/* MY HOURS (volunteer) */}
        {view === "myhours" && role === "volunteer" && (() => {
          const me = volunteers.find((v) => v.name.toLowerCase() === volunteerName.toLowerCase());
          const sessions = me ? [...me.sessions].sort((a, b) => new Date(b.date) - new Date(a.date)) : [];
          const totalMins = sessions.reduce((a, s) => a + s.minutes, 0);
          return (
            <>
              <div style={s.statGrid}>
                <div style={s.stat}><div style={s.statNum}>{formatDuration(totalMins)}</div><div style={s.statLabel}>Total Hours</div></div>
                <div style={s.stat}><div style={s.statNum}>{sessions.length}</div><div style={s.statLabel}>Sessions</div></div>
                <div style={s.stat}><div style={s.statNum}>{sessions.length > 0 ? formatDate(sessions[sessions.length - 1].date).split(",")[0] : "—"}</div><div style={s.statLabel}>First Session</div></div>
              </div>
              <div style={s.card}>
                <CT>My Hours — {volunteerName}</CT>
                {!me && (
                  <div style={{ color: TEAL_M, fontSize: "0.88rem", padding: "12px 0" }}>
                    Your name doesn't match a volunteer in the system yet. Ask your admin to add you under the name <strong>{volunteerName}</strong>.
                  </div>
                )}
                {me && sessions.length === 0 && <p style={{ color: TEAL_M, fontSize: "0.88rem" }}>No hours logged yet. Your admin will add them after each session.</p>}
                {sessions.map((r) => (
                  <div key={r.id} style={{ ...s.volRow, alignItems: "flex-start" }}>
                    <div style={{ minWidth: "88px", fontSize: "0.7rem", color: TEAL_M, paddingTop: "3px", fontWeight: "600" }}>{formatDate(r.date)}</div>
                    <div style={{ flex: 1 }}>
                      {r.notes && <div style={{ fontSize: "0.78rem", color: NAVY, fontWeight: "600" }}>{r.notes}</div>}
                      {!r.notes && <div style={{ fontSize: "0.75rem", color: TEAL_L }}>Volunteer session</div>}
                    </div>
                    <div style={s.badge}>{formatDuration(r.minutes)}</div>
                  </div>
                ))}
              </div>
            </>
          );
        })()}

        {/* AVAILABILITY */}
        {view === "availability" && role === "volunteer" && (
          <div style={s.card}>
            <CT>My Availability — {volunteerName}</CT>
            <p style={{ color: TEAL_M, fontSize: "0.87rem", marginBottom: "18px" }}>Go to the Calendar tab and tap any future date to mark yourself as available. Your selected dates appear below.</p>
            {(() => {
              const myDates = Object.entries(availability).filter(([, names]) => names.includes(volunteerName)).map(([date]) => date).sort();
              if (myDates.length === 0) return <p style={{ color: TEAL_L, fontSize: "0.87rem" }}>No dates marked yet. Head to the Calendar tab!</p>;
              return (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {myDates.map((d) => (
                    <div key={d} style={{ background: `${YELLOW}30`, color: "#8a6800", padding: "6px 13px", borderRadius: "4px", fontSize: "0.75rem", fontWeight: "700", display: "flex", alignItems: "center", gap: "8px" }}>
                      {formatDate(d)}
                      <button onClick={() => toggleAvailability(d)} style={{ background: "none", border: "none", cursor: "pointer", color: TEAL_M, fontSize: "0.9rem", padding: 0 }}>✕</button>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
        )}

        {view === "availability" && role === "admin" && (
          <div style={s.card}>
            <CT>Volunteer Availability Overview</CT>
            <p style={{ color: TEAL_M, fontSize: "0.87rem", marginBottom: "18px" }}>Dates volunteers have marked themselves as available.</p>
            {(() => {
              const datesWithAvail = Object.entries(availability).filter(([, names]) => names.length > 0).sort(([a], [b]) => a.localeCompare(b));
              if (datesWithAvail.length === 0) return <p style={{ color: TEAL_L, fontSize: "0.87rem" }}>No volunteers have marked availability yet.</p>;
              return datesWithAvail.map(([date, names]) => (
                <div key={date} style={s.volRow}>
                  <div style={{ background: YELLOW, color: NAVY, borderRadius: "3px", padding: "4px 10px", fontSize: "0.68rem", fontWeight: "800", flexShrink: 0, minWidth: "78px", textAlign: "center" }}>{formatDate(date)}</div>
                  <div style={{ flex: 1, display: "flex", flexWrap: "wrap", gap: "6px" }}>
                    {names.map((name) => (
                      <span key={name} style={{ background: OFFWHITE, border: "1px solid #dde3e8", color: NAVY, padding: "3px 9px", borderRadius: "3px", fontSize: "0.7rem", fontWeight: "600" }}>{name}</span>
                    ))}
                  </div>
                  <div style={s.badge}>{names.length} available</div>
                </div>
              ));
            })()}
          </div>
        )}

        {/* EMAIL REPORT */}
        {view === "email" && role === "admin" && (
          <>
            <div style={s.card}>
              <CT>Generate Email Report</CT>
              <div style={{ marginBottom: "20px" }}>
                <label style={s.label}>Report Type</label>
                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  {[["all","All Volunteers"],["individual","Individual"],["daterange","Date Range"]].map(([val, label]) => (
                    <button key={val} style={s.radio(reportType === val)} onClick={() => { setReportType(val); setReportPreview(null); }}>{label}</button>
                  ))}
                </div>
              </div>
              {reportType === "individual" && (
                <div style={{ marginBottom: "16px" }}><label style={s.label}>Select Volunteer</label>
                  <select style={s.input} value={reportVolId} onChange={(e) => { setReportVolId(e.target.value); setReportPreview(null); }}>
                    <option value="">— Select —</option>
                    {volunteers.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}
                  </select>
                </div>
              )}
              {reportType === "daterange" && (
                <div style={{ ...s.grid2, marginBottom: "16px" }}>
                  <div><label style={s.label}>From</label><input type="date" style={s.input} value={reportFrom} onChange={(e) => { setReportFrom(e.target.value); setReportPreview(null); }} /></div>
                  <div><label style={s.label}>To</label><input type="date" style={s.input} value={reportTo} onChange={(e) => { setReportTo(e.target.value); setReportPreview(null); }} /></div>
                </div>
              )}
              <div style={{ marginBottom: "22px" }}><label style={s.label}>Send To</label><input type="email" style={s.input} value={reportRecipient} onChange={(e) => setReportRecipient(e.target.value)} /></div>
              <button style={{ ...s.btn("primary"), opacity: reportLoading ? 0.6 : 1, minWidth: "190px" }} onClick={generateReport} disabled={reportLoading}>{reportLoading ? "Generating..." : "✦ Generate Report"}</button>
            </div>
            {reportLoading && (
              <div style={{ ...s.card, textAlign: "center", padding: "48px", background: TEAL_D }}>
                <div style={{ fontSize: "1.5rem", marginBottom: "12px", color: YELLOW }}>✦</div>
                <div style={{ fontWeight: "700", letterSpacing: "0.1em", textTransform: "uppercase", fontSize: "0.72rem", color: TEAL_L }}>Writing your volunteer report...</div>
              </div>
            )}
            {reportPreview && !reportLoading && (
              <div style={s.card}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "18px", flexWrap: "wrap", gap: "10px" }}>
                  <CT>Report Preview</CT>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button onClick={() => { navigator.clipboard.writeText(reportPreview.text); showToast("Copied!"); }} style={{ ...s.btn("outline"), padding: "8px 16px" }}>📋 Copy</button>
                    <button onClick={openMailto} style={{ ...s.btn("primary"), padding: "8px 16px" }}>📧 Open in Email App</button>
                  </div>
                </div>
                <div style={{ background: OFFWHITE, border: "1px solid #dde3e8", borderRadius: "4px", padding: "22px", whiteSpace: "pre-wrap", fontSize: "0.86rem", lineHeight: "1.8", color: NAVY, maxHeight: "460px", overflowY: "auto", fontFamily: FONT }}>{reportPreview.text}</div>
                <p style={{ fontSize: "0.68rem", color: TEAL_L, marginTop: "10px" }}>"Open in Email App" launches your mail client with this report pre-filled.</p>
              </div>
            )}
          </>
        )}

      </div>
      {toast && <div style={s.toast(toast.isError)}>{toast.msg}</div>}
    </div>
  );
}
